<loading [hidden]="!loading"></loading>

<div [hidden]="loading || index">
  <div>
    <div class="d-flex justify-content-between">
      <h2 class="d-flex w-100 justify-content-center">
        <b style="font-size: 18px"
          >Create Contact For
          {{ data.type === "company" ? "Company" : "Location" }}:
          {{ data.name }}</b
        >
      </h2>
      <!-- <button [hidden]="index" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button> -->
    </div>

    <!-- <br /> -->

    <!-- <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="bmd-label-floating">Name</label>
          <input
            type="text"
            class="form-control fctrl"
            id="nombre"
            name="nombre"
            #nombre="ngModel"
            required
            [(ngModel)]="contact.name"
            (click)="punteroNombre()"
            (keyup.tab)="punteroCorreo()"
          />
        </div>
      </div>
    </div> -->

    <div class="card-body">
      <div class="d-flex">
        <mat-form-field class="mr-3">
          <mat-label>Contact Name</mat-label>
          <input
            type="text"
            matInput
            name="contactName"
            #contactName="ngModel"
            [(ngModel)]="contact.name"
            required
          />
        </mat-form-field>
        <mat-form-field class="mr-3">
          <mat-label>Email</mat-label>
          <input
            type="text"
            matInput
            name="email"
            #email="ngModel"
            [(ngModel)]="contact.email"
            required
          />
        </mat-form-field>
      </div>
      <div class="d-flex">
        <mat-form-field class="mr-3">
          <mat-label>Work Phone</mat-label>
          <input
            required
            type="text"
            matInput
            name="phone"
            #phone="ngModel"
            [(ngModel)]="contact.phone"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Mobile Phone</mat-label>
          <input
            type="text"
            matInput
            name="mobilePhone"
            #mobilePhone="ngModel"
            [(ngModel)]="contact.mobilePhone"
          />
        </mat-form-field>
      </div>
      <!-- <div class="col-md-4">
        <div class="form-group">
          <label class="bmd-label-floating">Email</label>
          <input
            type="email"
            class="form-control fctrl"
            id="correo"
            name="correo"
            #correo="ngModel"
            required
            [(ngModel)]="contact.email"
            (click)="punteroCorreo()"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="bmd-label-floating">Work Phone</label>
          <input
            type="text"
            class="form-control fctrl"
            id="tel"
            name="tel"
            #tel="ngModel"
            [(ngModel)]="contact.phone"
            (click)="punteroTel()"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="bmd-label-floating">Mobile Phone</label>
          <input
            type="text"
            class="form-control fctrl"
            id="mobil"
            name="mobil"
            #mobil="ngModel"
            [(ngModel)]="contact.mobilePhone"
            (click)="punteroMobil()"
          />
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="card-body">
  <div [hidden]="loading || !index">
    <div>
      <div class="d-flex justify-content-between">
        <h2 class="d-flex w-100 justify-content-center">
          <b style="font-size: 18px"
            >{{ data.type === "company" ? "Company's" : "Location's" }} Contacts
            List: {{ data.name }}</b
          >
        </h2>
        <!-- <button (click)="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button> -->
      </div>

      <div class="d-flex justify-content-end">
        <button class="gts-btn-primary" (click)="new()">
          <span class="gts-btn-icon-left">person_add</span>
          <span class="gts-btn-text"> New Contact </span>
        </button>
      </div>
      <!-- <not-found [hidden]="contacts.length > 0"></not-found> -->
      <mat-progress-bar
        style="width: 100%"
        *ngIf="loadingContacts"
        id="loadingbar"
        mode="indeterminate"
      >
      </mat-progress-bar>
      <dinamic-table
        *ngIf="!loadingContacts"
        [id]="'contactTable'"
        [dbname]="'contactList'"
        [frontpaginate]="false"
        [data]="contactsData"
        [config]="configContact"
        [perPage]="itemsPorPaginaContact"
        [page]="paginaActualContact"
        [total_items_count]="totalItemsContact"
        [total_pages]="totalPaginasContact"
        (action_button)="actionContact($event)"
        (newConfig)="updateConfigContact($event)"
        [columnfilters]="filtrosContact"
        (buscar)="getData($event)"
      ></dinamic-table>
      <div class="material-datatables">
        <!-- <table
          id="contactTable"
          class="table table-striped table-no-bordered table-hover"
          cellspacing="0"
          width="100%"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th><b> ID </b></th>
              <th><b> Name </b></th>
              <th><b> Email </b></th>
              <th><b> Work Phone </b></th>
              <th><b> Mobile Phone </b></th>
              <th style="text-align: right"><b>Actions</b></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of contacts">
              <td style="width: 15px">{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.mobilePhone }}</td>
              <td style="text-align: right">
                <button
                  class="btn btn-sm btn-link btn-success btn-just-icon"
                  (click)="show(item)"
                  title="Edit Contact"
                >
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>

                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="delete(item.id)"
                  title="Delete"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>

  <div class="d-flex">
    <button
      [hidden]="index"
      class="mr-2 gts-btn-primary-outline"
      (click)="close()"
    >
      <!-- <i class="fa fa-reply" aria-hidden="true"></i> -->
      <span class="gts-btn-text"> Cancel </span>
    </button>
    <button
      [hidden]="index"
      class="gts-btn-primary mr-3"
      [disabled]="
        loading ||
        saving ||
        (contact.phone === '' && contact.mobilePhone === '')
      "
      (click)="save()"
    >
      <!-- <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i> -->
      <span class="gts-btn-text"> save </span>
    </button>
  </div>
</div>
